export const RECIPES_PER_PAGE = 8;

export const MAX_TIME_VALUE = 5;
export const MIN_TIME_VALUE = 1;

export const MAX_COST_VALUE = 5;
export const MIN_COST_VALUE = 1;

export const MIN_RATING_VALUE = 1;
export const MAX_RATING_VALUE = 5;
export const DEFAULT_RATING_VALUE = 3;
